
import React from "react";
import MainLayout from "@/layout/MainLayout";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

interface CaseStudyLayoutProps {
  title: string;
  industry: string;
  children: React.ReactNode;
}

export const CaseStudyLayout: React.FC<CaseStudyLayoutProps> = ({ 
  title, 
  industry, 
  children 
}) => {
  return (
    <MainLayout>
      <div className="pt-32 pb-20">
        <div className="container mx-auto px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-primary mb-8 hover:underline">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Home
          </Link>
          
          <div className="mb-12">
            <p className="text-primary mb-2">{industry}</p>
            <h1 className="mb-6">{title}</h1>
          </div>
          
          {children}
        </div>
      </div>
    </MainLayout>
  );
};
